import { isSensitiveObservabilityKey, REDACTED_VALUE } from "./redaction-rules";
import { sanitizeObservabilityUrl } from "./redaction-url";

const DOCUMENT_VIEW_TEXT_RE = /((?:https?:\/\/|\/\/)?[^\s"'<>]*\/document-view\/[^\s"'<>]+)/g;
const EMAIL_RE = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
const KEY_VALUE_RE = /([A-Za-z][\w$.-]*)(\s*[:=]\s*)([^&\s]+)/g;

function redactKeyValue(match: string, key: string, separator: string): string {
  return isSensitiveObservabilityKey(key) ? `${key}${separator}${REDACTED_VALUE}` : match;
}

/** Redacts sensitive key-value fragments, document URLs, and email addresses from text. */
export function sanitizeObservabilityText(text: string): string {
  return text
    .replace(KEY_VALUE_RE, redactKeyValue)
    .replace(DOCUMENT_VIEW_TEXT_RE, sanitizeObservabilityUrl)
    .replace(EMAIL_RE, REDACTED_VALUE);
}
